"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListListIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const ListListIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M15.7417 7.84521H9.58771", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M15.7417 15.0124H9.58771", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M17.5 5H9.58771", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M17.5 12.1672H9.58771", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("rect", { x: "1.38861", y: "4", width: "5.88399", height: "4.8258", rx: "1", fill: props.color || Theme_1.theme.palette.DARK_GRAY_80 }),
        react_1.default.createElement("rect", { x: "1.38861", y: "11.1672", width: "5.88399", height: "4.8258", rx: "1", fill: props.color || Theme_1.theme.palette.DARK_GRAY_80 })));
};
exports.ListListIcon = ListListIcon;
